import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Switch } from '../../components/ui/switch';
import { Loader2, UserPlus } from 'lucide-react';
import { toast } from 'sonner';
import api from '../../lib/api';

function Settings() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    api.get('/public/registration-status')
      .then((res) => setEnabled(!!res.data.enabled))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleToggle = async (value) => {
    setSaving(true);
    try {
      await api.put('/admin/settings/public-registration', { enabled: value });
      setEnabled(value);
      toast.success(value ? 'Public registration is now ENABLED' : 'Public registration is now DISABLED');
    } catch (e) {
      // interceptor shows error toast
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto" data-testid="settings-page">
      <h1 className="text-2xl font-bold text-gray-900 mb-1">Settings</h1>
      <p className="text-gray-500 mb-6">Platform-wide configuration (Super Admin only)</p>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <UserPlus className="w-5 h-5 text-blue-600" />
            Public IMU-CET Registration
          </CardTitle>
          <CardDescription>
            When enabled, the public "Register for Mock IMU-CET Test" page becomes accessible and the
            register button appears on the login page. When disabled, registration is closed for everyone.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {loading ? (
            <div className="flex items-center text-gray-500"><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Loading...</div>
          ) : (
            <div className="flex items-center justify-between rounded-lg border p-4">
              <div>
                <p className="font-medium text-gray-900">Allow public registrations</p>
                <p className="text-sm text-gray-500" data-testid="registration-status-text">
                  {enabled ? 'Registration is OPEN to the public' : 'Registration is CLOSED'}
                </p>
              </div>
              <Switch
                checked={enabled}
                onCheckedChange={handleToggle}
                disabled={saving}
                data-testid="registration-toggle"
              />
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}

export default Settings;
